import { render, staticRenderFns } from "./customg365.vue?vue&type=template&id=5a348e74&scoped=true"
import script from "./customg365.vue?vue&type=script&lang=js"
export * from "./customg365.vue?vue&type=script&lang=js"
import style0 from "./customg365.vue?vue&type=style&index=0&id=5a348e74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a348e74",
  null
  
)

export default component.exports